import { observer } from 'mobx-react';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import { CustomTextFieldRound } from '../../../styles/CustomTextField';
import palette from '../../../styles/palette';

const ZipCodeChip = ({ zipcode, households, onClick }) => {
  const InputAdornmentStart = {
    color: palette.soft_blue,
  };

  const InputAdornmentEnd = {
    color: palette.soft_blue,
  };

  const zipCodeStyles = {
    padding: '0.3em',
    fontWeight: '600',
  };

  return (
    <CustomTextFieldRound
      disabled
      id="outlined-disabled"
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={InputAdornmentStart}>
            <Typography variant="caption" sx={zipCodeStyles}>
              Zip Code {zipcode}
            </Typography>
            <Typography variant="caption">
              ({households ? households : 0} Addresses)
            </Typography>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end" sx={InputAdornmentEnd}>
            <HighlightOffOutlinedIcon onClick={onClick} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default observer(ZipCodeChip);
